import { render, staticRenderFns } from "./SkeletonPartnerCourses.vue?vue&type=template&id=71d8398c&scoped=true"
import script from "./SkeletonPartnerCourses.vue?vue&type=script&lang=js"
export * from "./SkeletonPartnerCourses.vue?vue&type=script&lang=js"
import style0 from "./SkeletonPartnerCourses.vue?vue&type=style&index=0&id=71d8398c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d8398c",
  null
  
)

export default component.exports